(function () {
    'use strict';

    angular
        .module('emails')
        .controller('SendSurveyController', SendSurveyController);

        SendSurveyController.$inject = ['$scope','$uibModal','$compile','toastr','SendSurveyService'];

    function SendSurveyController($scope,$uibModal,$compile,toastr,SendSurveyService) {
        var vm = this;

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = 0;
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        vm.query                  = {};
        vm.title                  = "";
        vm.flag                   = false;
        vm.formatDate             = formatDate;
        vm.getAll                 = getAll;
        vm.virtualFairSelected    = [];
        vm.virtualFairs           = [];
        vm.openSendSurveyModal    = openSendSurveyModal;



        function activate(){
            vm.getAll(vm.currentPage);
        }

        function getAll(currentPage) {
            SendSurveyService.getVirtualFairs(currentPage).then(function(response){
                vm.virtualFairs = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {
            });
        }

        function openSendSurveyModal(virtualFair) {

            $uibModal.open({
                templateUrl: 'templates/emails/sendSurvey/modal/template.modal.html',
                controller: 'SurveyModalController',
                controllerAs:'vm',
                resolve:
                {
                    virtualFair      : function () {
                        return virtualFair;
                    },
                }
            });
        }



        function formatDate(date){
            return new Date(date);
        }

        /* Pagination */
        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }
        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getAll(vm.page);
        }

        activate();
    }

})();